import { render, staticRenderFns } from "./SuggestionProposal.vue?vue&type=template&id=0e40ef82&scoped=true&"
import script from "./SuggestionProposal.vue?vue&type=script&lang=ts&"
export * from "./SuggestionProposal.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestionProposal.vue?vue&type=style&index=0&id=0e40ef82&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e40ef82",
  null
  
)

export default component.exports